import React from "react";

const PPPWhyPartnerSection = () => {
  const benefits = [
    {
      title: "Registered Saudi Holding Company",
      description: "CR No. 4030577100 – Jeddah",
      icon: "📋"
    },
    {
      title: "Authorized Investment & Consultancy",
      description: "Management of subsidiary and affiliated entities",
      icon: "💼"
    },
    {
      title: "Proven Experience",
      description: "Across engineering, infrastructure, telecom, and industrial sectors",
      icon: "🏆"
    },
    {
      title: "Strong Network Access",
      description: "Local and international partners in both government and private domains",
      icon: "🌐"
    },
    {
      title: "Full Compliance",
      description: "Saudi laws, regulations, and Saudization programs",
      icon: "✅"
    }
  ];

  return (
    <section 
      className="relative py-12 sm:py-16 md:py-20"
      style={{
        background: "linear-gradient(to bottom, #D2AB67 0%, #010101 100%)",
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12" data-aos="fade-up">
            <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              Why Partner with Semar Holding
            </h2>
            <div className="w-12 sm:w-16 md:w-24 h-1 bg-white mx-auto mb-6 sm:mb-8"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {benefits.slice(0, 3).map((benefit, index) => (
              <div
                key={index}
                className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 sm:p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg border border-white/20"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="text-4xl sm:text-5xl mb-4 sm:mb-6">{benefit.icon}</div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4 leading-tight">
                  {benefit.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-200 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mt-6 sm:mt-8 justify-items-center">
            {benefits.slice(3).map((benefit, index) => (
              <div
                key={index + 3}
                className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 sm:p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg border border-white/20 max-w-sm w-full"
                data-aos="fade-up"
                data-aos-delay={(index + 3) * 100}
              >
                <div className="text-4xl sm:text-5xl mb-4 sm:mb-6">{benefit.icon}</div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4 leading-tight">
                  {benefit.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-200 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 sm:mt-16 text-center" data-aos="fade-up">
            <div className="bg-[#c99c48] rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4 leading-tight">
                Ready to Partner with Us?
              </h3>
              <p className="text-sm sm:text-base md:text-lg text-white mb-4 sm:mb-6 max-w-3xl mx-auto leading-relaxed">
                Join us in advancing Saudi Arabia's Vision 2030 through strategic Public-Private Partnerships that deliver sustainable growth and national value.
              </p>
              <button className="bg-white text-[#c99c48] px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300 text-sm sm:text-base">
                Contact Us Today
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPPWhyPartnerSection;
